import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { LocaleService } from '@next/core-lib/i18n';
import { NavigationActions, ParentNavigationItem } from '@next/core-lib/navigation';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { Store } from '@ngrx/store';

import { Environment } from '../environment';
import { AppState } from './shared/models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [AgrWrapperSiteSidenavModule, RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly store = inject(Store<AppState>);
  private readonly locale = inject(LocaleService);
  private readonly env = inject(EnvironmentInjector) as Environment;

  readonly navigationItems: ParentNavigationItem[] = [
    {
      label: 'app.home.module',
      iconKey: 'home-dashboard',
      absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/home`,
    },
    {
      label: 'app.economy.module',
      icon: 'euro',
      absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/economy`,
    },
    {
      label: 'app.sustainability.module',
      icon: 'eco',
      children: [
        {
          label: 'app.sustainability.menu-items.sustainability',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/sustainability`,
        },
        {
          label: 'app.sustainability.menu-items.co2-deliveries',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/co2-deliveries`,
        },
        {
          label: 'app.sustainability.menu-items.co2-example-company',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/co2-example-company`,
        },
      ],
    },
    {
      label: 'app.feed.module',
      iconKey: 'lab_profile',
      children: [
        {
          label: 'app.feed.menu-items.rations',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/rations`,
        },
        {
          label: 'app.feed.menu-items.silage-results',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/silage-results`,
        },
        {
          label: 'labresults.title',
          relativeUrl: '/',
        },
        {
          label: 'app.feed.menu-items.deliveries',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/deliveries`,
        },
      ],
    },
    {
      label: 'app.dairyresults.module',
      iconKey: 'lab_profile',
      children: [
        {
          label: 'app.dairyresults.menu-items.dairy-overview',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/overview`,
        },
        {
          label: 'app.dairyresults.menu-items.production',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/production`,
        },
        {
          label: 'app.dairyresults.menu-items.individual-production',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/individual-production`,
        },
        {
          label: 'app.dairyresults.menu-items.milk-delivery',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/milk-delivery`,
        },
        {
          label: 'app.dairyresults.menu-items.month-summary',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/month-summary`,
        },
      ],
    },
    {
      label: 'app.fertility.module',
      iconKey: 'lab_profile',
      children: [
        {
          label: 'app.fertility.menu-items.fertility-summary',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/fertility-summary`,
        },
        {
          label: 'app.fertility.menu-items.individual-fertility',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/individual-fertility`,
        },
      ],
    },
    {
      label: 'app.health.module',
      iconKey: 'lab_profile',
      children: [
        {
          label: 'app.health.menu-items.health-summary',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/health-summary`,
        },
        {
          label: 'app.health.menu-items.individual-health',
          absoluteUrl: `${this.env.DAIRY_RESULTS_URL}/individual-health`,
        },
      ],
    },
  ];

  direction$ = this.locale.direction$;

  ngOnInit(): void {
    this.store.dispatch(
      NavigationActions.setNavigationItems({
        navigationItems: this.navigationItems,
      }),
    );
  }
}
